import { gql } from '@apollo/client'

export const DASHBOARDS_QUERY = gql`
  query DASHBOARDS_QUERY {
    dashboards {
      data {
        active
        availableTo {
          availableToUserIds
        }
        createdAt
        description
        id
        title
      }
    }
  }
`

export const DASHBOARDS_ITEMS_QUERY = gql`
  query DASHBOARDS_ITEMS_QUERY($input: DashboardItemsInput!) {
    dashboardItems(input: $input) {
      data {
        data {
          risksCount
        }
        item {
          createdAt
          dashboardId
          id
          itemType
          parentDashboardItemId
          position
          settings {
            description
            dropShadow
            filterId
            functionLink
            riskViewId
            riskTemplateId
            functionType
            height
            imageFilename
            imageUrl
            openInWindow
            padding
            showTitle
            title
            transparency
            width
            chartId
          }
          updatedAt
        }
      }
    }
  }
`
